import Vue from "vue";
import {
	Group,
	FetchGroup,
	CreateGroup,
	RemoveFromGroup
} from "@lab/types/groups";
import {
	getGroup,
	putGroup,
	postGroup,
	postGroupUser,
	deleteGroupUser
} from "@lab/api/hospitals.groups.api";

const state = {
	byID: [],
	isFetching: false,
	errorMessage: null,
	lastFetched: null // Timestamp
};

const getters = {
	getGroups: (state): Group[] =>
		state.byID ? Object.values(state.byID) : null,
	getGroup:
		(state: any) =>
		(id: number): Group => {
			return state.byID[id];
		},
	IsFetching: (state): boolean => state.isFetching,
	error: (state): string => state.errorMessage
};

const actions = {
	async fetchGroup({ commit }, { hospitalid, groupid }: FetchGroup) {
		try {
			commit("LOAD_START");
			const response = await getGroup(hospitalid, groupid);
			commit("LOAD_ITEM_SUCCESS", response);
		} catch (error) {
			// handle the error here
		}
	},
	async createGroup({ commit }, { hospitalid, group }: CreateGroup) {
		const { users } = group;

		// resetting the users array as not to disrupt the core
		group.users = [];

		const response = await postGroup(hospitalid, group);

		if (users.length) {
			users.forEach((user) => {
				postGroupUser(hospitalid, user.id, response.id);
			});
		}
		commit(`UPDATE_ITEM_SUCCESS`, response);

		return response;
	},
	async updateGroup({ commit }, { hospitalid, group }: CreateGroup) {
		const { users, id: groupid } = group;
		if (users.length) {
			users.forEach((user) => {
				postGroupUser(hospitalid, user.id, groupid);
			});
			// resetting the users array as not to disrupt the core
			group.users = [];
		}
		const response = await putGroup(hospitalid, group);
		commit(`UPDATE_ITEM_SUCCESS`, response);
	},
	removeUserFromGroup(
		{ commit },
		{ hospitalid, userid, groupid }: RemoveFromGroup
	) {
		deleteGroupUser({ hospitalid, groupid, userid });
	}
};

const mutations = {
	LOAD_LIST_SUCCESS(state: any, users: Group[]) {
		const byID = users.reduce((acc, val) => {
			acc[val.id] = val;
			return acc;
		}, {});
		Vue.set(state, "byID", byID);
		state.lastFetched = Date.now();
		state.isFetching = false;
	},
	LOAD_ITEM_SUCCESS(state: any, group: Group) {
		if (!group) return;
		Vue.set(state.byID, group.id, group);
		state.isFetching = false;
	},
	UPDATE_ITEM_SUCCESS(state: any, user: Group) {
		const { id } = user;
		const updated = { ...state.byID[id], ...user };
		Vue.set(state.byID, user.id, updated);
	},
	LOAD_START(state: any) {
		state.errorMessage = null;
		state.isFetching = true;
	}
};

export default { namespaced: true, state, getters, actions, mutations };
